import { Navigate } from '@tanstack/react-router'
import { isNativePlatform } from '../lib/platform'
import { LandingPage } from '../pages/LandingPage'
import { useAuth } from '../features/auth/useAuth'
import { readNativePublicState } from '../features/acquisition/acquisition-intent'

export function RootEntryPage() {
  const { user, isLoading } = useAuth()
  // Keep the native WebView on its local origin and perform exactly one
  // client-side route transition. Never canonicalize capacitor:// to https://.
  if (!isNativePlatform()) return <LandingPage />
  if (isLoading) return <div className="native-session-splash" role="status"><span className="brand-mark">PR</span><strong>PropertyReady</strong></div>
  return <Navigate to={user ? '/dashboard' : readNativePublicState()} replace />
}
